import { useMediaQuery } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import Toolbar from '@mui/material/Toolbar';
import { useTranslation } from 'src/hooks/use-translation';

import { useSettingsContext } from 'src/context/theme-settings-context';

import { useOffSetTop } from 'src/hooks/use-off-set-top';

import { AccountPopover, LanguagePopover, ThemeModeToggle } from 'src/layouts/common';
import { PlatformPopover } from 'src/layouts/dashboard/platform-popover';
import { bgBlur } from 'src/theme/css';

import MenuSvg from 'icons/monochrome/menu.svg';

// import Searchbar from '../common/searchbar';
import { HEADER, NAV } from '../config-layout';

// ----------------------------------------------------------------------

type Props = {
  onOpenNav?: VoidFunction;
};

export function Header({ onOpenNav }: Props) {
  const theme = useTheme();

  const settings = useSettingsContext();
  const { t } = useTranslation('', { keyPrefix: 'header' });

  const isNavMini = settings.themeLayout === 'mini';

  const lgUp = useMediaQuery(theme.breakpoints.up('lg'));

  const offsetTop = useOffSetTop(HEADER.H_DESKTOP);

  const renderContent = (
    <>
      {!lgUp && (
        <IconButton onClick={onOpenNav} data-testid="header-burger" aria-label={t('open-nav')}>
          <MenuSvg width={24} />
        </IconButton>
      )}

      <PlatformPopover sx={{ ml: 2 }} />

      {/* <Searchbar /> */}

      <Stack
        flexGrow={1}
        direction="row"
        alignItems="center"
        justifyContent="flex-end"
        spacing={{ xs: 0.5, sm: 1 }}
      >
        <ThemeModeToggle />

        <LanguagePopover />

        {/* <NotificationsPopover /> */}

        <AccountPopover />
      </Stack>
    </>
  );

  return (
    <AppBar
      sx={{
        height: HEADER.H_MOBILE,
        zIndex: theme.zIndex.appBar + 1,
        backgroundColor: theme.palette.background.default,
        transition: theme.transitions.create(['height'], {
          duration: theme.transitions.duration.shorter,
        }),
        ...(lgUp && {
          width: `calc(100% - ${NAV.W_VERTICAL + 1}px)`,
          height: HEADER.H_DESKTOP,
          ...(offsetTop && {
            height: HEADER.H_DESKTOP_OFFSET,
            ...bgBlur({
              color: theme.palette.background.default,
            }),
          }),
          ...(isNavMini && {
            width: `calc(100% - ${NAV.W_MINI + 1}px)`,
          }),
        }),
      }}
    >
      <Toolbar
        sx={{
          height: 1,
          px: { lg: 5 },
        }}
      >
        {renderContent}
      </Toolbar>
    </AppBar>
  );
}
